import { render, staticRenderFns } from "./RewardCardForm.vue?vue&type=template&id=0154507c&"
import script from "./RewardCardForm.vue?vue&type=script&lang=js&"
export * from "./RewardCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports